import { render } from "./password.vue?vue&type=template&id=61c35c11&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "./password.vue?vue&type=style&index=0&id=61c35c11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c35c11"]])

export default __exports__